function custom() {
  // init();
}
function init() {
  var inputFileTextCls = 'input-file-text';
  var tag = "<span class=".concat(inputFileTextCls, ">Keine Datei ausgew\xE4hlt</span>");
  jQuery("input[type='file']").parent().append(tag);
  $("input[type='file']").change(function () {
    var filename = this.files[0].name;
    var text = jQuery(this).parent().find(".".concat(inputFileTextCls));
    jQuery(text).text(filename);
  });
  var inputDate = jQuery("input[type='date']");
  inputDate.val(getFormatDate());
  setCaptionInSection(jQuery('.section-vacancy__bg-image'), 'Jetzt bewerben!');

  // Delete inline style in vacancy block
  deleteInlineStyleEl();

  // Update data picker in form on vacancies page
  updateDatePicker();

  // Trigger radiobox inputs
  radioFormTrigger();
}
function setCaptionInSection(section, caption) {
  var h1 = section.find('h1');
  h1.text(caption);
}
function getFormatDate() {
  var currentDate = new Date();
  var localDate = currentDate.toLocaleDateString().split('/');
  var year = localDate[2];
  var month = localDate[0];
  var day = localDate[1];
  var correctMonth = function correctMonth(month) {
    return month < 10 ? "0".concat(month) : month;
  };
  return "".concat(year, "-").concat(correctMonth(month), "-").concat(day);
}
function deleteInlineStyleEl() {
  var vacancyBody = '.vacancy-panel__body';
  var arrTags = ['p', 'div', 'span', 'iframe', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'li', 'br', 'input'];
  $(vacancyBody).find('br').remove();
  $.each(arrTags, function (index, value) {
    if ($(vacancyBody).find(value).is('#apply_form_wpforms, #apply_form_wpforms *')) return;
    $(vacancyBody).find(value).attr('style', '');
    $(vacancyBody).find(value).attr('data-mce-style', '');
    $(vacancyBody).find(value).attr('data-mce-bogus', '');
  });
}
function updateDatePicker() {
  var $datePicker = $('.cx2_personal-birthDate');
  $datePicker.attr('style', '');
  $('input.cx2_personal-birthDate').attr('style', '');
}
function radioFormTrigger() {
  var parentComponent = '.recommend-contacts-radio';
  var radioComponent = '.radio-component';
  var inputParent = '.contact-form__item';
  var disabledCls = 'disabled';
  var $radioButton = jQuery(parentComponent).find('.wpcf7-list-item input[type="radio"]');
  $radioButton.on('click', triggerRadioBUttons);
  function triggerRadioBUttons() {
    var valueInput = jQuery(this).attr('value');
    var parent = jQuery("[data-value-input=".concat(valueInput, "]"));
    var inputs = parent.find(inputParent);
    addDisabledToInputs("".concat(radioComponent, " ").concat(inputParent));
    $radioButton.parent().attr('checked', false);
    jQuery(this).parent().attr('checked', true);
    jQuery(inputs).each(function (i, item) {
      if (jQuery(item).hasClass(disabledCls)) {
        triggerAttrs('removeClass', item, false);
      }
    });
  }
  function addDisabledToInputs(inputs) {
    jQuery(inputs).each(function (i, item) {
      triggerAttrs('addClass', item, true);
    });
  }
  function triggerAttrs(method, parent, flagDisabled) {
    jQuery(parent)[method](disabledCls);
    var input = jQuery(parent).find('input');
    input.attr(disabledCls, flagDisabled);
  }
  function setDefaultRadioButton() {
    jQuery($radioButton[0]).parent().attr('checked', true);
  }
  setDefaultRadioButton();
}
export default custom;